/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * A client legal entity that the freelancer has worked / currently works with
 * @export
 * @interface FreelancerClientLegalEntityResource
 */
export interface FreelancerClientLegalEntityResource {
    /**
     * The client legal entity ID
     * @type {string}
     * @memberof FreelancerClientLegalEntityResource
     */
    id: string;
    /**
     * The client legal entity name
     * @type {string}
     * @memberof FreelancerClientLegalEntityResource
     */
    name?: string;
}

/**
 * Check if a given object implements the FreelancerClientLegalEntityResource interface.
 */
export function instanceOfFreelancerClientLegalEntityResource(value: object): value is FreelancerClientLegalEntityResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FreelancerClientLegalEntityResourceFromJSON(json: any): FreelancerClientLegalEntityResource {
    return FreelancerClientLegalEntityResourceFromJSONTyped(json, false);
}

export function FreelancerClientLegalEntityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerClientLegalEntityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function FreelancerClientLegalEntityResourceToJSON(value?: FreelancerClientLegalEntityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

